import angular from 'angular';
import Creative from 'cars-ng-ad/lib/creative';
import Gpt from 'cars-ng-ad/lib/gpt';
import Krux from 'cars-ng-ad/lib/krux';
import Native from 'cars-ng-ad/lib/native';
import OnTheLot from 'cars-ng-ad/lib/onTheLot';
import Targeting from 'cars-ng-ad/lib/targeting';
import Viewport from 'cars-ng-browser/lib/viewport';

import adService from 'cars-ng-ad/lib/ad.service';

import requestIdleCallbackShim from 'cars-ng-ad/lib/requestIdleCallbackShim';

export default angular.module('cars.ad', [
    Creative,
    Gpt,
    Krux,
    Native,
    OnTheLot,
    Targeting,
    Viewport
])

    .config([() => {}])

    .factory('adService', adService)

    .name;
